import bg from 'assets/images/plus-bg.png';
import cn from 'classnames';
import { ReactChild } from 'react';
import { I18nt } from 'utils';
import styles from './BannerWithImage.module.less';

interface Props {
	children: ReactChild | ReactChild[];
	className?: string;
}

export default function BannerWithImage({ children, className }: Props) {
	return (
		<div className={cn(styles.bannerContainer, className)}>
			{children}
			<img className={styles.bgImage} src={bg} alt={I18nt('isbm')} />
		</div>
	);
}
